import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BOOK_PRODUCT_ID } from '../constants/productConfig';

function AboutusScreen() {
  const { t } = useTranslation();
  const storyImages = [
    '/site-assets/reading-session-blurred.jpg',
    '/site-assets/book-cover-flat.jpg',
    '/site-assets/book-open-spread.jpg',
    '/site-assets/layout-detail-open.jpg',
    '/site-assets/family-story-spread.jpg',
    '/site-assets/book-page-stack.jpg'
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % storyImages.length
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [storyImages.length]);

  return (
    <Container className="py-3">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <h1 className="text-center mb-5 mt-2" style={{ 
            fontSize: '3rem', 
            color: '#FF69B4',
            fontFamily: 'Georgia, serif'
          }}>
            {t('about.title')}
          </h1>
          
          <div className="text-center mb-5 position-relative">
            <div style={{
              display: 'inline-block',
              padding: '10px',
              background: 'linear-gradient(135deg, #FFE4E1, #FFF0F5, #E6E6FA)',
              borderRadius: '20px',
              boxShadow: '0 8px 16px rgba(255, 105, 180, 0.3)'
            }}>
              <Image 
                src={storyImages[currentImageIndex]} 
                alt={t('about.imageAlt')} 
                fluid 
                rounded 
                className="mb-3"
                style={{ 
                  maxHeight: '460px',
                  width: '100%',
                  objectFit: 'cover',
                  transition: 'opacity 0.5s ease-in-out',
                  border: '4px solid white'
                }}
              />
            </div>
          </div>

          <div className="mb-5 p-4" style={{ 
            background: 'linear-gradient(to right, #FFF9E6, #FFE4F0)',
            borderRadius: '15px',
            borderLeft: '5px solid #FFB6C1'
          }}>
            <h2 className="mb-3" style={{ color: '#FF69B4', fontFamily: 'Georgia, serif' }}>
              {t('about.section1Title')}
            </h2>
            <p className="lead" style={{ fontSize: '1.15rem', lineHeight: '1.8' }}>
              {t('about.section1Text')}
            </p>
          </div>

          <div className="mb-5 p-4" style={{ 
            background: 'linear-gradient(to right, #F0E6FF, #FFE6F0)',
            borderRadius: '15px',
            borderLeft: '5px solid #DDA0DD'
          }}>
            <h2 className="mb-3" style={{ color: '#9370DB', fontFamily: 'Georgia, serif' }}>
              {t('about.section2Title')}
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              {t('about.section2Text')}
            </p>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              {t('about.section2Text2')}
            </p>
          </div>

          <div className="mb-5 p-4" style={{ 
            background: 'linear-gradient(to right, #E6F3FF, #FFF0E6)',
            borderRadius: '15px',
            borderLeft: '5px solid #87CEEB'
          }}>
            <h2 className="mb-3" style={{ color: '#4682B4', fontFamily: 'Georgia, serif' }}>
              {t('about.section3Title')}
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              {t('about.section3Text')}
            </p>
            <p className="fw-bold" style={{ 
              fontSize: '1.3rem', 
              color: '#FF69B4',
              textAlign: 'center',
              padding: '15px',
              background: 'white',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}>
              {t('about.section3Text2')}<br/>
              <span style={{ fontSize: '0.9rem', color: '#666' }}>{t('about.section3Text3')}</span>
            </p>
          </div>

          <div className="mb-4 p-4" style={{ 
            background: 'linear-gradient(135deg, #FFF0F5, #E6E6FA, #FFE4E1)',
            borderRadius: '15px',
            border: '3px dashed #FFB6C1'
          }}>
            <h2 className="mb-3 text-center" style={{ color: '#FF69B4', fontFamily: 'Georgia, serif' }}>
              {t('about.section4Title')}
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', textAlign: 'center' }}>
              {t('about.section4Text')}
            </p>
            <p className="text-center" style={{ 
              fontSize: '1.3rem', 
              fontFamily: 'Georgia, serif',
              color: '#9370DB',
              marginTop: '20px'
            }}>
              {t('about.section4Text2')}<br/>
              <span style={{ fontSize: '1.5rem', color: '#FF69B4' }}>
                {t('about.section4Text3')}
              </span>
            </p>
          </div>

          <div className="text-center mt-5 p-4" style={{ 
            background: 'linear-gradient(135deg, #FFE4E1, #E6E6FA)',
            borderRadius: '20px',
            border: '4px solid #FFB6C1',
            boxShadow: '0 8px 16px rgba(255, 105, 180, 0.2)'
          }}>
            <Link
              to={`/product/${BOOK_PRODUCT_ID}`}
              style={{ textDecoration: 'none' }}
            >
              <p className="mb-0" style={{ 
                fontSize: '1.4rem', 
                fontFamily: 'Georgia, serif',
                color: '#4682B4',
                fontStyle: 'italic'
              }}>
                {t('about.quote')}
              </p>
            </Link>
            <p className="mt-3" style={{ fontSize: '1.1rem', color: '#666' }}>
              {t('about.signature')}
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default AboutusScreen;
